import merge from 'lodash.merge';
import { dmpconnectConfigurationActionConstants } from '../constants';
import env from '../../envVariables';

const initialState = {
  clientId: env.REACT_APP_ES_LOGIN_OPENID_CLIENT_ID,
  clientSecret: env.REACT_APP_ES_LOGIN_OPENID_CLIENT_SECRET,
  signKey: env.REACT_APP_ES_LOGIN_OPENID_SIGN_KEY,
  authorizeEndpoint: env.REACT_APP_ES_LOGIN_OPENID_AUTH_ENDPOINT,
  tokenEndpoint: env.REACT_APP_ES_LOGIN_OPENID_TOKEN_ENDPOINT,
  jwksEndpoint: env.REACT_APP_ES_LOGIN_OPENID_JWKS_ENDPOINT,
  userInfoEndpoint: env.REACT_APP_ES_LOGIN_OPENID_USERINFOS_ENDPOINT,
  userInfoMethod: env.REACT_APP_ES_LOGIN_OPENID_USERINFOS_METHOD,
  endSessionEndpoint: env.REACT_APP_ES_LOGIN_OPENID_ENDSESSION_ENDPOINT,
  scope: env.REACT_APP_ES_LOGIN_OPENID_SCOPE,
  acrValues: env.REACT_APP_ES_LOGIN_OPENID_ACRVALUES,
  responseType: 'code',
  deactivatePCKE: Number(env.REACT_APP_ES_LOGIN_OPENID_PKCE) !== 1,
  pkceSendSecret: Number(env.REACT_APP_ES_LOGIN_OPENID_PKCE_SEND_CLIENT_SECRET) === 1,
  redirectURI: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/authcallback`,
  logoutURI: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/logout`,
  callUserInfos: Number(env.REACT_APP_ES_LOGIN_OPENID_USERINFOS) === 1,
  userInfosMapper: env.REACT_APP_ES_LOGIN_OPENID_USERINFOS_MAPPER,
  loginCheckMapper: env.REACT_APP_ES_LOGIN_CHECK_MAPPING,
  sendTokenDcParams: Number(env.REACT_APP_ES_LOGIN_OPENID_PSC_CONFIG_FROM_DMPCONNECTJS) === 0,
  activateCiba: Number(env.REACT_APP_ES_LOGIN_OPENID_ACTIVATE_CIBA) === 1,
};

export function openIDConfiguration(state = initialState, action) {
  switch (action.type) {
    case dmpconnectConfigurationActionConstants.SET_OPENID_CONFIG: {
      return merge({}, state, { [action.key]: action.value });
    }
    case dmpconnectConfigurationActionConstants.RESET_OPENID_CONFIG_FROM_ENV:
      return merge({}, state, initialState);
    default:
      return state;
  }
}
